import {Component, ElementRef, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {TextFieldBrowser} from '../text-field-browser';

@Component({
  selector: 'app-number-field',
  templateUrl: './number-field.component.html',
  styleUrls: ['./number-field.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NumberFieldComponent),
    multi: true
  }],
})
export class NumberFieldComponent implements OnInit, OnDestroy, ControlValueAccessor {

  @Input()
  size = 2;
  @Input()
  label: string;
  @Input()
  errors: {};
  @Output()
  changed: EventEmitter<any> = new EventEmitter();
  @Output()
  goToPrevious: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  goToNext: EventEmitter<any> = new EventEmitter<any>();
  age: string;
  @ViewChild('el')
  textFieldElement: ElementRef<HTMLElement>;
  textFieldBrowser: TextFieldBrowser;

  onChange: any = () => { };
  onTouched: any = () => { };

  get value() {
    return this.age;
  }

  set value(value: string) {
    this.age = value;
    this.textFieldBrowser.onChange(value);
    this.onChange(value);
    this.onTouched();
  }

  constructor() { }

  ngOnInit(): void {
    this.textFieldBrowser = new TextFieldBrowser(this.size);
    this.textFieldBrowser.subscribe(this.goToPrevious, this.goToNext);
  }

  ngOnDestroy() {
    this.textFieldBrowser.unsubscribe();
  }

  writeValue(value: any): void {
    if (value) {
      this.value = value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  get hasError() {
    if (!this.errors) {
      return false;
    }
    return Object.keys(this.errors).length > 0;
  }

  focus() {
    if (this.textFieldElement) {
      this.textFieldElement.nativeElement.focus();
    }
  }

  keyDown(event: KeyboardEvent) {
    switch (event.key) {
      case TextFieldBrowser.KEY_UP:
        this.age = (parseFloat(this.value) + 1).toString();
        break;
      case TextFieldBrowser.KEY_DOWN:
        this.age = (parseFloat(this.value) - 1).toString();
        break;
      default:
        this.textFieldBrowser.onKeyDown(event);
        break;
    }
  }
}
